import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { filter, map, take, timeout } from 'rxjs/operators';
import { GetUserByEmailGQL } from 'src/graphql/generated/graphql.generated';
import { StoreService } from 'src/store/store.service';
import { isNullOrEmpty } from 'src/util/string';
import { networkTimeout } from 'src/util/rxjs/helper';
import { firstValueOrUndefined } from 'src/util/rxjs';
import * as AuthStoreActions from './auth-store.actions';

@Injectable({ providedIn: 'root' })
export class AuthStoreEffects {
  public token$: Observable<any> = createEffect(
    () =>
      this._actions$.pipe(
        ofType<AuthStoreActions.TokenLoaded>(AuthStoreActions.TOKEN_LOADED),
        filter((action) => action.oktaClaims != null),
        map((action) => action.oktaClaims),
        map(async (claims) => {
          if (!isNullOrEmpty(claims.sub)) {
            const email = claims.sub;
            await firstValueOrUndefined(
              this._storeService
                .upsertEntitiesFromGraphQL(this._userGql, { email })
                .pipe(timeout(networkTimeout('AuthStore.AuthStoreEffects')), take(1)),
            );
          }
        }),
      ),
    { dispatch: false },
  );
  constructor(
    private _actions$: Actions,
    private _storeService: StoreService,
    private readonly _userGql: GetUserByEmailGQL,
  ) {}
}
